import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import axios from 'axios';

const TratamentoDeDados = () => {
    const [lastBackup, setLastBackup] = useState(null);
    const [uploadFile, setUploadFile] = useState(null);
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    useEffect(() => {
        const fetchLastBackupTime = async () => {
            try {
                const response = await axios.get(`${apiBaseURL}/api/backup/last/`);
                if (response.data.last_backup_time) {
                    setLastBackup(new Date(response.data.last_backup_time).toLocaleString());
                } else {
                    setLastBackup('Ainda não houve nenhum backup feito.');
                }
            } catch (error) {
                console.error('Erro ao buscar o último backup:', error);
            }
        };

        fetchLastBackupTime();
    }, []);

    const handleBackup = async () => {
        try {
            const response = await axios.post(`${apiBaseURL}/api/backup/create/`);
            alert(response.data.message);
            setLastBackup(new Date().toLocaleString()); // Atualiza o último backup
        } catch (error) {
            console.error('Erro ao fazer backup:', error);
            alert('Erro ao fazer backup');
        }
    };

    const handleFileChange = (event) => {
        setUploadFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!uploadFile) {
            alert('Por favor, selecione um arquivo para upload.');
            return;
        }

        const formData = new FormData();
        formData.append('backup_file', uploadFile);

        try {
            const response = await axios.post(`${apiBaseURL}/api/backup/upload/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert(response.data.message);
        } catch (error) {
            console.error('Erro ao fazer upload do backup:', error);
            alert('Erro ao fazer upload do backup');
        }
    };

    return (
        <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h6">Tratamento de Dados</Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
                Último backup: {lastBackup ? lastBackup : 'Carregando...'}
            </Typography>

            <Box sx={{ mt: 4 }}>
                <Button variant="contained" color="primary" onClick={handleBackup} sx={{ m: 1 }}>
                    Fazer Backup
                </Button>
                <Button
                    variant="contained"
                    component="label"
                    sx={{ m: 1 }}
                >
                    Upload da Base de Dados
                    <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                    />
                </Button>
                <Button variant="contained" color="secondary" onClick={handleUpload} sx={{ m: 1 }}>
                    Enviar Backup
                </Button>
            </Box>
        </Box>
    );
};

export default TratamentoDeDados;
